const normalize = (value: unknown): string => {
  if (value === null || value === undefined) return "";

  if (value instanceof Date) return value.toISOString().toLowerCase();

  if (Array.isArray(value)) {
    return value.map(normalize).join(" ");
  }

  if (typeof value === "object") {
    return Object.values(value as Record<string, unknown>).map(normalize).join(" ");
  }

  return String(value).toLowerCase();
};

export const rowMatchesSearch = <T extends object>(
  row: T,
  search?: string
) => {
  const query = search?.trim().toLowerCase();

  if (!query) return true;

  return normalize(row).includes(query);
};

export const filterRowsBySearch = <T extends object>(
  rows: T[],
  search?: string
) => rows.filter((row) => rowMatchesSearch(row, search));
